import React from 'react';
import { Button } from 'primereact/button';

const CalcFormButton = ({ className, ...props }) => {
  const customClasses = `bg-secondary rounded-3xl font-extrabold px-6 py-3.5 text-base leading-tight ${className || ''}`.trim();

  return <Button className={customClasses} {...props} />;
};

export default CalcFormButton;